/* src/app/pages/ui-kit/components/info-block-view/info-block-view.component.scss */
.info-block-view {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.info-block-view__caption {
  margin: 0;
  font-size: 13px;
  color: var(--ion-color-medium-shade);
  line-height: 1.4;
}
.info-block-view .stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 16px;
  margin-top: 8px;
}
.info-block-view .stat-item {
  text-align: center;
  padding: 12px;
  background: var(--ion-color-light-shade);
  border-radius: 6px;
}
.info-block-view .stat-item .stat-value {
  display: block;
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--ion-color-primary);
}
.info-block-view .stat-item .stat-label {
  display: block;
  font-size: 0.9rem;
  color: var(--ion-color-medium-shade);
  margin-top: 4px;
}
.info-block-view .button-group {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}
/*# sourceMappingURL=info-block-view.component.css.map */
